module.exports = __webpack_public_path__ + "assets/cambridge_university_logo.859556d1e042809d4e685d9a2cc5d205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cambridge_university_logo.png
// module id = 77
// module chunks = 0